import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './breton-genesi/HeroSection';
import { IntroSection } from './breton-genesi/IntroSection';
import { VideoShowcaseSection } from './breton-genesi/VideoShowcaseSection';
import { MachineModelsSection } from './breton-genesi/MachineModelsSection';
import { FeaturesSection } from './breton-genesi/FeaturesSection';
import { VideoSection } from './breton-genesi/VideoSection';
import { BottomCTASection } from './breton-genesi/BottomCTASection';
export function GenesiPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2309">
      <SeoBar data-id="element-2310" />
      <Header data-id="element-2311" />
      <main className="flex-grow" data-id="element-2312">
        <div className="w-full bg-white pb-20" data-id="element-2313">
          <HeroSection data-id="element-2314" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-2315">
            <IntroSection data-id="element-2316" />
            <VideoShowcaseSection data-id="element-2317" />
            <MachineModelsSection data-id="element-2318" />
            <FeaturesSection data-id="element-2319" />
            <VideoSection data-id="element-2320" />
            <BottomCTASection data-id="element-2321" />
          </div>
        </div>
      </main>
      <Footer data-id="element-2322" />
    </div>;
}